import { useContext } from "react";
import { CollinsUserContext } from "../context/CollinsUserContext";

export const useUserContext = () => useContext(CollinsUserContext);
